import * as z from "zod";

/**
 * Horizontal rule (divider) node.
 */
const HorizontalRuleNodeSchema_ = z.object({
  type: z.literal("horizontalRule"),
});

/** Base type from schema inference (no index signature) */
type HorizontalRuleNodeBase = z.infer<typeof HorizontalRuleNodeSchema_>;

/** Full type with index signature for FlowContentNode compatibility */
export type HorizontalRuleNode = HorizontalRuleNodeBase & {
  [key: string]: unknown;
};

export const HorizontalRuleNodeSchema: z.ZodType<HorizontalRuleNode> =
  HorizontalRuleNodeSchema_;
